import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';

import LetapeSunmoonlakeDesImg1 from '../../assets/img/letape-sunmoonlake-desc-img1.jpg';
import LetapeSunmoonlakeDesImg2 from '../../assets/img/letape-sunmoonlake-desc-img2.jpg';
import LetapeSunmoonlakeDesImg3 from '../../assets/img/letape-sunmoonlake-desc-img3.jpg';
import LetapeSunmoonlakeDesImg4 from '../../assets/img/letape-sunmoonlake-desc-img4.jpg';

const Desc = ({language}) => {
    return (
        <section className="letape-sunmoonlake-desc">
            <Container>
                <Row className="align-items-center">
                    <Col md={6} className="text-center">
                        <h2>{language === "Chinese" ? "島嶼之心。世外桃源" : "Heart of the Island, a Hidden Paradise"}</h2>
                        {language === "Chinese" ? <p>
                            坐擁山水繚繞的天然名勝湖景 <br />
                            享譽全球的環潭自行車路線 <br />
                            CNN評選為「世界10大最美自行車道」
                        </p> : <p>
                            Embraced by mountains and water, this celebrated natural lake is home to a world-famous cycling route around its shores, named by CNN one of the "10 Most Beautiful Bike Routes in the World."
                        </p>}
                        
                        {language === "Chinese" ? <p>
                            騎著單車暢遊日月潭 <br/>
                            沈浸在映山映水、如詩如畫的景致中
                        </p> : <p>Cycle around Sun Moon Lake and immerse yourself in poetic, picture-perfect scenes of mountains mirrored in the water.</p>}
                        
                    </Col>
                    <Col md={6}>
                        <img src={LetapeSunmoonlakeDesImg1} alt="" />
                    </Col>
                </Row>
                <Row className="align-items-center">
                    <Col md={6} className="text-center">
                        <h2>{language === "Chinese" ? "逐鹿傳說的起源之地" : "Where the White Deer Legend Began"}</h2>
                        {language === "Chinese" ? <p>
                            邵族，擁有深厚文化底蘊的原住民族，是日月潭地區最早的住民。邵語「thao」意為「人」，自「ita thao」（我們是人）提取「thao」一字而為「邵族」。
                        </p> : <p>The Thao, an Indigenous people with a rich cultural heritage, were the earliest inhabitants of the Sun Moon Lake area. In the Thao language, "thao" means "people"; the tribe's name comes from the phrase "ita thao" ("we are people").</p>}
                        
                        {language === "Chinese" ? <p>
                            相傳邵族的祖先在一次狩獵中追逐一頭白鹿，無意間發現了魚蝦豐饒的日月潭，被這片美麗的湖泊吸引，決定舉族遷居於此。
                        </p> : <p>Legend has it that Thao ancestors, while chasing a white deer on a hunt, stumbled upon Sun Moon Lake, teeming with fish and shrimp. Captivated by its beauty, they decided to move their entire tribe here.</p>}
                        
                        {language === "Chinese" ? <p>
                            與湖水、山林相依相存，發展出魅力滿滿的人文特色。
                        </p> : <p>Living in harmony with the lake and the forested mountains, they developed a distinctive and captivating culture.</p>}
                        
                    </Col>
                    <Col md={6}>
                        <img src={LetapeSunmoonlakeDesImg2} alt="" />
                    </Col>
                </Row>
                <Row className="align-items-center">
                    <Col md={6} className="text-center">
                        <h2>{language === "Chinese" ? "原住民美食饗宴" : "A Feast of Indigenous Flavors"}</h2>
                        {language === "Chinese" ? <div>
                            <p>生鮮奇力魚漬、有總統魚之稱且肉質細嫩的「曲腰魚」、拜鰻祭特色「白鰻麻糬」</p>
                            <p>擁有「鳥不踏」稱號的刺蔥是涼拌、煮湯、糕點好料，醃肉與釀酒等在地好味，都是不可錯過的邵族美食佳餚。</p>
                        </div> : <div>
                                <p>Fresh pickled chiri fish; tender "curved-back fish," known as the "President's Fish"; and "white eel mochi," a specialty of the Thao Eel Festival.</p>
                                <p>Prickly ash, nicknamed "birds won't perch," is a star ingredient in salads, soups and pastries, while locally cured meats and home-brewed wine round out the Thao dishes you won't want to miss.</p>
                        </div>}
                        
                    </Col>
                    <Col md={6}>
                        <img src={LetapeSunmoonlakeDesImg3} alt="" />
                    </Col>
                </Row>
                <Row className="align-items-center">
                    <Col md={6} className="text-center">
                        <h2>{language === "Chinese" ? "打造甘醇韻味詩篇" : "A Mellow Ode to Tea & Coffee"}</h2>
                        {language === "Chinese" ? <div>
                            <p>清晨的薄霧輕輕籠罩著茶園，茶葉在陽光的沐浴下散發出獨特的香氣</p>
                            <p>咖啡豆在濕潤的氣候中慢慢成熟，手工採摘後經過精心烘焙</p>
                            <p>每一口都是對這片土地深情的致敬</p>
                        </div> : <div>
                                <p>Morning mist gently drapes the tea gardens as the leaves release their distinctive aroma in the sunshine.</p>
                                <p>Coffee beans ripen slowly in the humid climate, then are hand-picked and carefully roasted.</p>
                                <p>Each sip is a heartfelt tribute to this land.</p>
                        </div>}
                        
                    </Col>
                    <Col md={6}>
                        <img src={LetapeSunmoonlakeDesImg4} alt="" />
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default Desc